// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1MALw","colMaxWidth":"Table_colMaxWidth__1pPfR"};